"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATE = void 0;
exports.DATE = {
    alias: 'DATA',
    description: 'Cria uma data a partir dos parâmetros ano, mês e dia',
    arg_names: ['ano', 'mês', 'dia'],
    args_description: ['ano da data', 'mês da data', 'dia da data'],
};
